import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FlexColumn, FlexColumnAlignCenter } from '../shared/Flex';
import { Text } from '../ui-elements/Main/Text';
import { colors } from '../ui-elements/Main/MainTheme';
import { ArrowUpCircle } from 'react-feather';
import { MenuNotif } from './MenuNotif';
import { OrgInfoContext } from '../organization/org-info';
import { balanceToUsd } from '@/helpers/app/balance';
import { AccountInfoContext } from '../account/account-info';
import { accountBillingPath } from '@/helpers/app/routes';
import { useNavigationActions } from '@/lib/navigation';
import { orgBalanceRemainingSelector } from '@/redux/app/selectors/organization';

export const BalanceMenuHeader = () => {
  const size = 18;
  const { autoFill } = useContext(OrgInfoContext);
  const balanceRemaining = useSelector(orgBalanceRemainingSelector);
  const { subdomain } = useContext(AccountInfoContext);
  const { navigate } = useNavigationActions();

  return (
    <FlexColumn>
      <FlexColumnAlignCenter style={{ padding: '15px', borderBottom: '1px solid rgba(224, 198, 183, 0.5)' }}>
        <Text fontSize="16px" fontWeight={600}>Account Balance</Text>
        <Text fontSize="30px" fontWeight={800} color={colors.balanceGreen}>{balanceToUsd(balanceRemaining)}</Text>
      </FlexColumnAlignCenter>
      {autoFill !== undefined && (
        <MenuNotif
          icon={<ArrowUpCircle size={size} style={{ rotate: '45deg' }} />}
          title={`Auto-fill: ${autoFill ? 'Active' : 'Disabled'}`}
          subtitle="Configure Auto-fill Balance"
          onClick={() => navigate({ path: accountBillingPath(subdomain), params: {} })}
        />
      )}
    </FlexColumn>
  )
}
